
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/modules",
      function () {
        return require("private-next-pages/settings/modules.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/modules"])
      });
    }
  